{
  "AGENT_MGMT": {
    "HEADER": "에이전트",
    "HEADER_BTN_TXT": "에이전트 추가",
    "LOADING": "에이전트 목록을 가져오는 중",
    "DESCRIPTION": "에이전트는 사용자 메시지를 보고 응답할 수 있는 고객 지원팀의 구성원입니다. 아래 목록에는 계정의 모든 에이전트가 나와 있습니다.",
    "LEARN_MORE": "사용자 역할에 대해 알아보기",
    "AGENT_TYPES": {
      "ADMINISTRATOR": "관리자",
      "AGENT": "에이전트"
    },
    "COUNT": "{n}명의 에이전트 | {n}명의 에이전트",
    "LIST": {
      "404": "이 계정에 연결된 에이전트가 없습니다.",
      "TITLE": "팀 내 에이전트 관리",
      "DESC": "팀에 에이전트를 추가/제거할 수 있습니다.",
      "NAME": "이름",
      "EMAIL": "이메일",
      "STATUS": "상태",
      "ACTIONS": "액션",
      "VERIFIED": "인증됨",
      "VERIFICATION_PENDING": "인증 보류",
      "AVAILABLE_CUSTOM_ROLE": "사용 가능한 사용자 정의 역할 권한"
    },
    "ADD": {
      "TITLE": "팀에 에이전트 추가",
      "DESC": "받은 메시지함에 대한 지원을 처리할 수 있는 사용자를 추가할 수 있습니다.",
      "CANCEL_BUTTON_TEXT": "취소",
      "FORM": {
        "NAME": {
          "LABEL": "에이전트 이름",
          "PLACEHOLDER": "에이전트 이름을 입력하십시오."
        },
        "AGENT_TYPE": {
          "LABEL": "역할",
          "PLACEHOLDER": "역할을 선택하십시오.",
          "ERROR": "역할이 필요합니다."
        },
        "EMAIL": {
          "LABEL": "이메일 주소",
          "PLACEHOLDER": "에이전트의 이메일 주소를 입력하십시오."
        },
        "SUBMIT": "에이전트 추가"
      },
      "API": {
        "SUCCESS_MESSAGE": "에이전트가 성공적으로 추가되었습니다.",
        "EXIST_MESSAGE": "에이전트 이메일이 이미 사용 중입니다. 다른 이메일 주소를 시도하십시오.",
        "ERROR_MESSAGE": "Woot 서버에 연결할 수 없습니다. 나중에 다시 시도하십시오."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "삭제",
      "API": {
        "SUCCESS_MESSAGE": "에이전트가 성공적으로 삭제되었습니다.",
        "ERROR_MESSAGE": "Woot 서버에 연결할 수 없습니다. 나중에 다시 시도하십시오."
      },
      "CONFIRM": {
        "TITLE": "삭제 확인",
        "MESSAGE": "삭제하시겠습니까? ",
        "YES": "예, 삭제합니다. ",
        "NO": "아니요, 유지합니다. "
      }
    },
    "EDIT": {
      "TITLE": "에이전트 수정",
      "FORM": {
        "NAME": {
          "LABEL": "에이전트 이름",
          "PLACEHOLDER": "에이전트 이름을 입력하십시오."
        },
        "AGENT_TYPE": {
          "LABEL": "역할",
          "PLACEHOLDER": "역할을 선택하십시오.",
          "ERROR": "역할이 필요합니다."
        },
        "EMAIL": {
          "LABEL": "이메일 주소",
          "PLACEHOLDER": "에이전트의 이메일 주소를 입력하십시오."
        },
        "AGENT_AVAILABILITY": {
          "LABEL": "가용성",
          "PLACEHOLDER": "가용성 상태를 선택하십시오.",
          "ERROR": "가용성이 필요합니다."
        },
        "SUBMIT": "에이전트 수정"
      },
      "BUTTON_TEXT": "수정",
      "CANCEL_BUTTON_TEXT": "취소",
      "API": {
        "SUCCESS_MESSAGE": "에이전트가 성공적으로 업데이트되었습니다.",
        "ERROR_MESSAGE": "Woot 서버에 연결할 수 없습니다. 나중에 다시 시도하십시오."
      },
      "PASSWORD_RESET": {
        "ADMIN_RESET_BUTTON": "비밀번호 재설정",
        "ADMIN_SUCCESS_MESSAGE": "비밀번호 재설정 안내 이메일이 에이전트에게 전송되었습니다.",
        "SUCCESS_MESSAGE": "에이전트 비밀번호가 성공적으로 재설정되었습니다.",
        "ERROR_MESSAGE": "Woot 서버에 연결할 수 없습니다. 나중에 다시 시도하십시오."
      }
    },
    "SEARCH_PLACEHOLDER": "에이전트 검색...",
    "NO_RESULTS": "검색과 일치하는 에이전트가 없습니다",
    "SEARCH": {
      "NO_RESULTS": "검색 결과가 없습니다."
    },
    "MULTI_SELECTOR": {
      "PLACEHOLDER": "없음",
      "TITLE": {
        "AGENT": "에이전트 선택",
        "TEAM": "팀 선택"
      },
      "LIST": {
        "NONE": "없음"
      },
      "SEARCH": {
        "NO_RESULTS": {
          "AGENT": "에이전트를 찾을 수 없습니다.",
          "TEAM": "팀을 찾을 수 없습니다."
        },
        "PLACEHOLDER": {
          "AGENT": "에이전트 검색",
          "TEAM": "팀 검색",
          "INPUT": "에이전트 검색"
        }
      }
    }
  }
}
